import { Diagnostics } from './Diagnostics'
import type { LoggerLevel } from './types'

export interface Logger {
  info: <T>(message: string, metaData?: Record<string, T>) => void
  warn: <T>(message: string, metaData?: Record<string, T>) => void
  error: <T>(message: string, metaData?: Record<string, T>) => void
  record: <T>(
    message: string,
    metaData?: Record<string, T>,
    level?: LoggerLevel
  ) => void
  debug: <T>(message: string, metaData?: Record<string, T>) => Promise<void>
}

export class DiagnosticsLogger implements Logger {
  constructor(private source: string, private prefix?: string) {}

  private withPrefix(message: string): string {
    return this.prefix ? `[${this.prefix}] ${message}` : message
  }

  record<T>(
    message: string,
    metaData?: Record<string, T>,
    level?: LoggerLevel
  ): void {
    Diagnostics.record({
      message: this.withPrefix(message),
      metaData: { source: this.source, ...metaData },
      level
    })
  }

  info<T>(message: string, metaData?: Record<string, T>): void {
    this.record(message, metaData, 'info')
  }

  warn<T>(message: string, metaData?: Record<string, T>): void {
    this.record(message, metaData, 'warning')
  }

  error<T>(message: string, metaData?: Record<string, T>): void {
    this.record(message, metaData, 'error')
  }

  async debug<T>(message: string, metaData?: Record<string, T>): Promise<void> {
    if (!(await Diagnostics.inDebugMode())) return
    this.record(message, metaData, 'info')
  }
}
